/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Compliance_Chip1_LabelInputs */



/**
* | output |
* | --- |
* | "How do I start enforcing a policy?" |
*
* @param {Uno_Edu_Intro_Compliance_Chip1_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_compliance_chip1_label = /** @type {((inputs?: Uno_Edu_Intro_Compliance_Chip1_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Compliance_Chip1_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie beginne ich, eine Richtlinie durchzusetzen?")
	return /** @type {LocalizedString} */ ("How do I start enforcing a policy?")
});